import { Link } from 'react-router-dom'
import { FooterBand } from '@azoya-spa/ui'
import '@azoya-spa/ui/styles.css'
import { useSiteContent } from '../../hooks/useSiteContent'
import fallback from '../../api/fallback/practicalInfo.json'
import { frenchNumberToTelHref } from '../../utils/phone'
import { useConsent } from '../../consent/ConsentContext'
import { emailClicked, itineraryClicked, phoneClicked } from '../../analytics/events'

const SOCIAL_ICONS = {
  Instagram: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
    </svg>
  ),
  Facebook: (
    <svg viewBox="0 0 24 24">
      <path d="M15 8h-2a2 2 0 0 0-2 2v10M9 13h6" />
    </svg>
  ),
}

function Footer() {
  const info = useSiteContent('practical-info', fallback)
  const { openPanel } = useConsent()

  return (
    <FooterBand
      contact={
        <>
          <h2>Contact</h2>
          <p><a target="_blank" rel="noopener noreferrer" href={info.mapsUrl} onClick={itineraryClicked}>{info.address}</a></p>
          <p><a href={frenchNumberToTelHref(info.phone)} onClick={phoneClicked}>{info.phone}</a></p>
          <p><a href={`mailto:${info.email}`} onClick={emailClicked}>{info.email}</a></p>
        </>
      }
      social={
        info.socialLinks.length > 0 ? (
          <>
            <h2>Suivez-nous</h2>
            <div className="azoya-footer-band-social-icons">
              {info.socialLinks.map((link) => (
                <a key={link.label} href={link.url} target="_blank" rel="noopener noreferrer" aria-label={link.label}>
                  {SOCIAL_ICONS[link.label] ?? <span>{link.label}</span>}
                </a>
              ))}
            </div>
          </>
        ) : null
      }
      hours={
        <>
          <h2>Horaires</h2>
          {info.openingLines.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </>
      }
      partners={
        info.partnersUrl ? (
          <>
            <h2>Partenaires</h2>
            <Link to={info.partnersUrl}>{info.partnersLabel}</Link>
          </>
        ) : null
      }
      legal={
        <>
          <Link to="/mentions-legales">Mentions légales</Link>
          <Link to="/cgu">CGU</Link>
          {/* Point d'entrée permanent : retirer son consentement doit être
              aussi simple que de le donner, donc accessible de partout. */}
          <button type="button" onClick={openPanel}>
            Gérer mes cookies
          </button>
        </>
      }
      copyright={info.copyright}
    />
  )
}

export default Footer
